import { BETA_CONSENT_KEY, BETA_CONSENT_ACCEPTED } from '@/domain/user';

export const getters = {
    isUserInBetaProgram(state) {
        const userConsent = state.userInfo.consents && state.userInfo.consents.find(({ type }) => type === BETA_CONSENT_KEY);
        return !!(userConsent && userConsent.status === BETA_CONSENT_ACCEPTED);
    },
};